import { Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { EMAIL_TEMPLATES_PATH } from '@/models/emailTemplate'

/** Opens the Email Templates page in a new tab, so the draft being written survives. */
export function CreateEmailTemplateButton() {
  return (
    <Button variant="outline" size="sm" href={EMAIL_TEMPLATES_PATH} target="_blank" className="justify-start">
      <Plus className="mr-1.5 size-4" />
      Create template
    </Button>
  )
}
